export const MAX_SET_SIZE = 10;
export const MIN_SET_SIZE = 3;
